











































import { Component, Vue } from 'vue-property-decorator'
import cardContainer from '@/common/cardMap/cardLayout/cardContainer.vue'
import cardWraper from '@/common/cardMap/cardLayout/cardWraper.vue'
import cardTable from '@/common/cardMap/cardLayout/cardTable.vue'
import cardTableInfo from '@/common/cardMap/cardLayout/cardTableInfo.vue'
import ioCard from '@/common/cardMap/cardLayout/ioCard.vue'
import outCard from '@/common/cardMap/cardLayout/out-card.vue'

@Component({
  name: 'test',
  components: {
    cardContainer,
    cardWraper,
    cardTable,
    cardTableInfo,
    ioCard,
    outCard
  }
})
export default class extends Vue {
}
